import paymentsubscriptionService from '../../services/paymentsubscription'

const state = {
  

}

// getters
const getters = {
 
}

// actions
const actions = {
    async updatePaymentSubscriptionAction (context, data) {
        await paymentsubscriptionService.updatePaymentSubscriptionByRestaurant(data);
    }
     
}

// mutations
const mutations = {
    
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}